export const BUS_COMPANY_USERS_CHANGED = 'bus-company-users-changed';